import RichUpdatesItemShareAlert from './RichUpdatesItemShareAlert';

export default RichUpdatesItemShareAlert;
